<img src="{{imageUrl}}">
<div class="inline-editable" data-attribute="title" data-placeholder="{{t "editor.inspector.properties.title.title"}}">{{getLocaleText title}}</div>
